import ReactModal from 'react-modal';
import { Container, Content, Head } from '../modal/modal.styles';
import P from '../texts/p/P';
import Button from '../button/Button';
import Card from '../card/Card';
import Icon from '../icon/Icon';
import theme from '../../styles/theme';
import {
  MISSING_USD_QUOTATION_MODAL_BODY,
  MISSING_USD_QUOTATION_MODAL_TITLE,
} from '../../utils/usdQuotationMessages';

interface MissingUsdQuotationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onGoToQuotations: () => void;
}

const MissingUsdQuotationModal = ({
  isOpen,
  onClose,
  onGoToQuotations,
}: MissingUsdQuotationModalProps) => (
  <ReactModal
    isOpen={isOpen}
    onRequestClose={onClose}
    style={{
      overlay: {
        background: 'rgba(0,0,0,0.65)',
        zIndex: 1,
      },
      content: {
        alignSelf: 'center',
        borderRadius: '16px',
        width: '448px',
        height: 'auto',
        maxHeight: '90vh',
        margin: '0 auto',
        padding: '0',
        overflow: 'auto',
      },
    }}
    shouldFocusAfterRender={false}
    ariaHideApp={false}
  >
    <Container>
      <Content>
        <Head>
          <P type="3" variant="neutral" weight="bold" withMargin={false}>
            {MISSING_USD_QUOTATION_MODAL_TITLE}
          </P>
          <Icon
            name="cancel_outline"
            cursor="pointer"
            onClick={onClose}
            variant="neutral"
          />
        </Head>

        <P type="3" variant="neutral" modifier="regular" withMargin={false}>
          {MISSING_USD_QUOTATION_MODAL_BODY}
        </P>

        <Card
          gap="16px"
          display="flex"
          margin={{ top: '4' }}
          justifyContent="flex-end"
          alignItems="center"
          minHeight="40px"
        >
          <Button
            variant="secondary"
            size="lg"
            onClick={onClose}
            style={{
              color: theme.colors.primary.text.regular,
              fontWeight: 400,
            }}
          >
            Cerrar
          </Button>
          <Button variant="primary" size="lg" onClick={onGoToQuotations}>
            Ir a Cotizaciones
          </Button>
        </Card>
      </Content>
    </Container>
  </ReactModal>
);

export default MissingUsdQuotationModal;
